var _a, _SocketIoCheckerSocketModel_socket, _SocketIoCheckerSocketModel_onRefreshStream, _SocketIoCheckerSocketModel_createSocket;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import io from 'socket.io-client';
import { HashGenerator } from '../../../util/hash/HashGenerator';
import { PushListService } from '../../../view/main/push/PushListService';
const KEY_NEW_STREAM = 'new_stream_notification';
export class SocketIoCheckerSocketModel {
    constructor(host, privateKey) {
        _SocketIoCheckerSocketModel_socket.set(this, void 0);
        _SocketIoCheckerSocketModel_onRefreshStream.set(this, null);
        __classPrivateFieldSet(this, _SocketIoCheckerSocketModel_socket, __classPrivateFieldGet(_a, _a, "m", _SocketIoCheckerSocketModel_createSocket).call(_a, host, privateKey), "f");
        __classPrivateFieldGet(this, _SocketIoCheckerSocketModel_socket, "f").on('connect', () => {
            console.log('connected');
        });
        __classPrivateFieldGet(this, _SocketIoCheckerSocketModel_socket, "f").on('refresh_streams', (raw) => {
            __classPrivateFieldGet(this, _SocketIoCheckerSocketModel_onRefreshStream, "f").call(this, raw);
        });
        __classPrivateFieldGet(this, _SocketIoCheckerSocketModel_socket, "f").on(KEY_NEW_STREAM, (raw) => {
            PushListService.push({
                hash: new HashGenerator().generate('newStreamNotification'),
                title: '새 방송 알림',
                icon: raw.icon,
                body: `${raw.nickname} 방송을 시작합니다.`,
                mute: true,
                channel: 'local-stream',
                read: false,
                timestamp: new Date().getTime(),
            });
        });
    }
    onRefreshStream(callback) {
        __classPrivateFieldSet(this, _SocketIoCheckerSocketModel_onRefreshStream, callback, "f");
    }
}
_a = SocketIoCheckerSocketModel, _SocketIoCheckerSocketModel_socket = new WeakMap(), _SocketIoCheckerSocketModel_onRefreshStream = new WeakMap(), _SocketIoCheckerSocketModel_createSocket = function _SocketIoCheckerSocketModel_createSocket(host, privateKey) {
    return io.connect(`https://${host}?key=${privateKey}`);
};
